import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { isNotDefined } from '@hsp/utilities';

import { dashboardService } from 'services';
import { IDashboardState } from 'types/store/dashboard';

const initialState: IDashboardState = {
  donorComposite: {
    data: [],
    loading: false,
  },
  mailByState: {
    data: [],
    loading: false,
  },
  mailInsights: {
    data: [],
    loading: false,
  },
  mailPerformance: {
    data: [],
    loading: false,
  },
  topClientMailing: {
    data: [],
    loading: false,
  },
};

export const getDonorComposite = createAsyncThunk('dashboard/getDonorComposite', async () => {
  const result = await dashboardService.getDonorComposite();

  if (isNotDefined(result) || result.failure) {
    return [];
  }

  return [...(result.dataContainer ?? [])];
});

export const getMailByState = createAsyncThunk('dashboard/getMailByState', async () => {
  const result = await dashboardService.getMailByState();

  if (isNotDefined(result) || result.failure) {
    return [];
  }

  return [...(result.dataContainer ?? [])];
});

export const getMailInsights = createAsyncThunk('dashboard/getMailInsights', async () => {
  const result = await dashboardService.getMailInsights();

  if (isNotDefined(result) || result.failure) {
    return [];
  }

  return [...(result.dataContainer ?? [])];
});

export const getMailPerformance = createAsyncThunk('dashboard/getMailPerformance', async () => {
  const result = await dashboardService.getMailPerformance();

  if (isNotDefined(result) || result.failure) {
    return [];
  }

  return [...(result.dataContainer ?? [])];
});

export const getTopClientMailing = createAsyncThunk('dashboard/getTopClientMailing', async () => {
  const result = await dashboardService.getTopClientMailing();

  if (isNotDefined(result) || result.failure) {
    return [];
  }

  return [...(result.dataContainer ?? [])];
});

export const dashboardSlice = createSlice({
  extraReducers: (builder) => {
    builder.addCase(getDonorComposite.fulfilled, (state, { payload: data }) => {
      state.donorComposite.loading = false;

      if (isNotDefined(data)) {
        state.donorComposite.error = 'Unknown error occurred';

        return;
      }

      state.donorComposite.data = data;

      delete state.donorComposite.error;
    });
    builder.addCase(getDonorComposite.pending, (state) => {
      state.donorComposite.loading = true;
    });
    builder.addCase(getDonorComposite.rejected, (state, { error }) => {
      state.donorComposite.error = error;
      state.donorComposite.loading = false;
    });
    builder.addCase(getMailByState.fulfilled, (state, { payload: data }) => {
      state.mailByState.loading = false;

      if (isNotDefined(data)) {
        state.mailByState.error = 'Unknown error occurred';

        return;
      }

      state.mailByState.data = data;

      delete state.mailByState.error;
    });
    builder.addCase(getMailByState.pending, (state) => {
      state.mailByState.loading = true;
    });
    builder.addCase(getMailByState.rejected, (state, { error }) => {
      state.mailByState.error = error;
      state.mailByState.loading = false;
    });
    builder.addCase(getMailInsights.fulfilled, (state, { payload: data }) => {
      state.mailInsights.loading = false;

      if (isNotDefined(data)) {
        state.mailInsights.error = 'Unknown error occurred';

        return;
      }

      state.mailInsights.data = data;

      delete state.mailInsights.error;
    });
    builder.addCase(getMailInsights.pending, (state) => {
      state.mailInsights.loading = true;
    });
    builder.addCase(getMailInsights.rejected, (state, { error }) => {
      state.mailInsights.error = error;
      state.mailInsights.loading = false;
    });
    builder.addCase(getMailPerformance.fulfilled, (state, { payload: data }) => {
      state.mailPerformance.loading = false;

      if (isNotDefined(data)) {
        state.mailPerformance.error = 'Unknown error occurred';

        return;
      }

      state.mailPerformance.data = data;

      delete state.mailPerformance.error;
    });
    builder.addCase(getMailPerformance.pending, (state) => {
      state.mailPerformance.loading = true;
    });
    builder.addCase(getMailPerformance.rejected, (state, { error }) => {
      state.mailPerformance.error = error;
      state.mailPerformance.loading = false;
    });
    builder.addCase(getTopClientMailing.fulfilled, (state, { payload: data }) => {
      state.topClientMailing.loading = false;

      if (isNotDefined(data)) {
        state.topClientMailing.error = 'Unknown error occurred';

        return;
      }

      state.topClientMailing.data = data;

      delete state.topClientMailing.error;
    });
    builder.addCase(getTopClientMailing.pending, (state) => {
      state.topClientMailing.loading = true;
    });
    builder.addCase(getTopClientMailing.rejected, (state, { error }) => {
      state.topClientMailing.error = error;
      state.topClientMailing.loading = false;
    });
  },
  initialState,
  name: 'dashboard',
  reducers: {},
});

export const dashboardReducer = dashboardSlice.reducer;
